var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoopIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.991,
    height: 18,
    viewBox: "0 0 23.991 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-change",
    transform: "translate(-11.541 -27.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(11.541 27.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M46.627,23.409H44A9.25,9.25,0,0,0,35.023,14.4a8.583,8.583,0,0,0-4.374,1.214l-.48.3a.465.465,0,0,0-.152.62l.758,1.241a.391.391,0,0,0,.556.135l.4-.243a6.522,6.522,0,0,1,3.287-.917,6.951,6.951,0,0,1,6.75,6.636H39.22a.44.44,0,0,0-.354.674l3.691,6.069a.389.389,0,0,0,.683,0l3.691-6.069A.4.4,0,0,0,46.627,23.409Z",
    transform: "translate(-23.025 -14.4)",
    fill: "#db0106"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M18.786,39.032a.391.391,0,0,0-.556-.135l-.4.243a6.522,6.522,0,0,1-3.287.917,7.011,7.011,0,0,1-6.775-6.635h2.553a.44.44,0,0,0,.354-.674l-3.691-6.1a.389.389,0,0,0-.683,0L2.606,32.721a.44.44,0,0,0,.354.674h2.6A9.269,9.269,0,0,0,14.539,42.4a8.723,8.723,0,0,0,4.374-1.214l.48-.3a.465.465,0,0,0,.152-.62Z",
    transform: "translate(-2.541 -24.404)",
    fill: "#db0106"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopIcon);
export default __webpack_public_path__ + "static/media/loopIcon.d329df0bdcb3f57acb8cf4332bbf43a5.svg";
export { ForwardRef as ReactComponent };